import { render, staticRenderFns } from "./todo.vue?vue&type=template&id=6bd9aaf3&scoped=true&"
import script from "./todo.vue?vue&type=script&lang=js&"
export * from "./todo.vue?vue&type=script&lang=js&"
import style0 from "./todo.vue?vue&type=style&index=0&id=6bd9aaf3&prod&lang=scss&scoped=true&"
import style1 from "./todo.vue?vue&type=style&index=1&id=6bd9aaf3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9aaf3",
  null
  
)

export default component.exports